import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  AfterViewInit,
  Renderer2,
  SimpleChanges,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[collapse]',
  standalone: false
})
export class AppCollapseDirective implements OnChanges, AfterViewInit, OnDestroy {

  @Input() collapse: boolean = false;
  @Input() isAnimated: boolean = true;
  @Input() open: boolean = true;
  private viewReady: boolean = false;
  private observer!: MutationObserver;

  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    this.applyInitialState();
    this.watchDom();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.viewReady) return;

    if (changes['collapse']) {
      this.collapse ? this.hide() : this.show();
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private applyInitialState() {
    if (this.collapse) {
      this.renderer.setStyle(this.el.nativeElement, 'height', '0px');
    } else {
      this.renderer.removeStyle(this.el.nativeElement, 'height');
    }
  }

  private show() {
    const el = this.el.nativeElement;

    if (!this.isAnimated) {
      this.renderer.removeStyle(el, 'height');
      return;
    }

    this.renderer.setStyle(el, 'height', '0px');
    el.offsetHeight; // force reflow

    const target = el.scrollHeight;
    this.renderer.setStyle(el, 'transition', 'height 300ms ease');
    this.renderer.setStyle(el, 'height', `${target}px`);

    el.addEventListener('transitionend', () => {
      this.renderer.removeStyle(el, 'height');
    }, { once: true });
  }

  private hide() {
    const el = this.el.nativeElement;

    if (!this.isAnimated) {
      this.renderer.setStyle(el, 'height', '0px');
      return;
    }

    const current = el.scrollHeight;

    this.renderer.setStyle(el, 'transition', 'height 300ms ease');
    this.renderer.setStyle(el, 'height', `${current}px`);
    el.offsetHeight;

    this.renderer.setStyle(el, 'height', '0px');
  }

  private watchDom() {
    this.observer = new MutationObserver(() => {
      if (!this.collapse) this.adjustToContent();
    });

    this.observer.observe(this.el.nativeElement, { childList: true, subtree: true });
  }

    private adjustToContent() {
        if (this.collapse) return;

        const el = this.el.nativeElement;
        const height = el.scrollHeight;

        this.renderer.setStyle(el, 'height', `${height}px`);

        el.addEventListener('transitionend', () => {
            if (!this.collapse) {
                this.renderer.removeStyle(el, 'height');
            }
        }, { once: true });
    }
}
